import { render, staticRenderFns } from "./NoticeArea.vue?vue&type=template&id=5acda730&scoped=true"
import script from "./NoticeArea.vue?vue&type=script&lang=ts"
export * from "./NoticeArea.vue?vue&type=script&lang=ts"
import style0 from "./NoticeArea.vue?vue&type=style&index=0&id=5acda730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acda730",
  null
  
)

export default component.exports